export default "__VITE_ASSET__bFFsUIyJ__"